import {memo, useEffect, useState} from 'react';
import {formatUtc} from '@/lib/date-format';

const UTCText = () => {
  const [text, setText] = useState('');

  useEffect(() => {
    const update = () => {
      setText(formatUtc(new Date()));
    };
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="ml-[18px] flex items-center">
      <div className="h-[30px] w-px bg-border" />
      <span className="ml-[18px] text-sm text-spanish-gray-1">
        {text}
      </span>
    </div>
  );
};

export default memo(UTCText);
